/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Achievementsblade_Bronze1Inputs */

const id_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perunggu`)
};

const ms_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gangsa`)
};

const da_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const de_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const en_us2_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const es_es2_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronce`)
};

const es_mx2_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronce`)
};

const fil_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const fr_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const it_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronzo`)
};

const hu_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronz`)
};

const nl_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brons`)
};

const no_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronse`)
};

const pl_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brąz`)
};

const pt_br2_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const pt_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const ro_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronz`)
};

const fi_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronssi`)
};

const sv_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brons`)
};

const vi_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng`)
};

const tr_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronz`)
};

const cs_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronz`)
};

const bg_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бронз`)
};

const ru_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бронза`)
};

const uk_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бронза`)
};

const ar_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برونز`)
};

const hi_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कांस्य`)
};

const th_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทองแดง`)
};

const ja_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブロンズ`)
};

const zh_cn2_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const zh_hant1_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

const ko_components_achievementsblade_bronze1 = /** @type {(inputs: Components_Achievementsblade_Bronze1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronze`)
};

/**
* | output |
* | --- |
* | "Bronze" |
*
* @param {Components_Achievementsblade_Bronze1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_achievementsblade_bronze1 = /** @type {((inputs?: Components_Achievementsblade_Bronze1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Achievementsblade_Bronze1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_achievementsblade_bronze1(inputs)
	if (locale === "ms") return ms_components_achievementsblade_bronze1(inputs)
	if (locale === "da") return da_components_achievementsblade_bronze1(inputs)
	if (locale === "de") return de_components_achievementsblade_bronze1(inputs)
	if (locale === "en-US") return en_us2_components_achievementsblade_bronze1(inputs)
	if (locale === "es-ES") return es_es2_components_achievementsblade_bronze1(inputs)
	if (locale === "es-MX") return es_mx2_components_achievementsblade_bronze1(inputs)
	if (locale === "fil") return fil_components_achievementsblade_bronze1(inputs)
	if (locale === "fr") return fr_components_achievementsblade_bronze1(inputs)
	if (locale === "it") return it_components_achievementsblade_bronze1(inputs)
	if (locale === "hu") return hu_components_achievementsblade_bronze1(inputs)
	if (locale === "nl") return nl_components_achievementsblade_bronze1(inputs)
	if (locale === "no") return no_components_achievementsblade_bronze1(inputs)
	if (locale === "pl") return pl_components_achievementsblade_bronze1(inputs)
	if (locale === "pt-BR") return pt_br2_components_achievementsblade_bronze1(inputs)
	if (locale === "pt") return pt_components_achievementsblade_bronze1(inputs)
	if (locale === "ro") return ro_components_achievementsblade_bronze1(inputs)
	if (locale === "fi") return fi_components_achievementsblade_bronze1(inputs)
	if (locale === "sv") return sv_components_achievementsblade_bronze1(inputs)
	if (locale === "vi") return vi_components_achievementsblade_bronze1(inputs)
	if (locale === "tr") return tr_components_achievementsblade_bronze1(inputs)
	if (locale === "cs") return cs_components_achievementsblade_bronze1(inputs)
	if (locale === "bg") return bg_components_achievementsblade_bronze1(inputs)
	if (locale === "ru") return ru_components_achievementsblade_bronze1(inputs)
	if (locale === "uk") return uk_components_achievementsblade_bronze1(inputs)
	if (locale === "ar") return ar_components_achievementsblade_bronze1(inputs)
	if (locale === "hi") return hi_components_achievementsblade_bronze1(inputs)
	if (locale === "th") return th_components_achievementsblade_bronze1(inputs)
	if (locale === "ja") return ja_components_achievementsblade_bronze1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_achievementsblade_bronze1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_achievementsblade_bronze1(inputs)
	return ko_components_achievementsblade_bronze1(inputs)
});
export { components_achievementsblade_bronze1 as "components.achievementsBlade.bronze" }